<div class="dvf-list__transactions panel" data-dvf-list-transactions>
    <% for (var transactionKey in transactions) { %>
        <button class="dvf-transaction dvf-transaction--list btn-reset"
            data-dvf-transaction-id="<%= transactions[transactionKey].id %>" data-ua-hit-type="event"
            data-ua-event-category="DVF" data-ua-event-action="go:dvf_past_sale"
            data-ua-event-label="dvf_explorer:dvf_past_sales_list:item" data-dvf-transaction>
            <% if (transactions[transactionKey].address_name || transactions[transactionKey].city_name ) { %>
            <div class="dvf-transaction__address">
                <%= transactions[transactionKey].address_name %> - <%= transactions[transactionKey].city_name %>
            </div>
            <% } %>

            <% if (transactions[transactionKey].item_type_name || transactions[transactionKey].area || transactions[transactionKey].room_count) { %>
            <div class="dvf-transaction__features">
                <% if (transactions[transactionKey].item_type) { %>
                <span class="dvf-transaction__feature">
                    <%= transactions[transactionKey].item_type.name %>
                </span>
                <% } %>

                <% if (transactions[transactionKey].room_count) { %>
                <span class="dvf-transaction__feature">
                    <%= transactions[transactionKey].room_count %>
                </span>
                <% } %>

                <% if (transactions[transactionKey].area) { %>
                <span class="dvf-transaction__feature" data-dvf-transaction-area>
                    <%= transactions[transactionKey].area %>
                </span>
                <% } %>
            </div>
            <% } %>

            <% if (transactions[transactionKey].price) { %>
            <div class="dvf-transaction__price">
                <span class="dvf-transaction__price-value"
                    data-dvf-transaction-price-value><%= transactions[transactionKey].price %></span>
                <span class="dvf-transaction__price-date">
                    <%= transactions[transactionKey].item_type.key === 'ITEM_TYPE.HOUSE' ? 'Vendue en': 'Vendu en' %>
                    <%= transactions[transactionKey].sale_at %>
                </span>
            </div>
            <% } %>

            <div class="dvf-transaction__more">
                Voir le prix actualisé
            </div>
        </button>
    <% } %>
</div>
